import { render, staticRenderFns } from "./dl_person.vue?vue&type=template&id=af00acc0&"
import script from "./dl_person.vue?vue&type=script&lang=js&"
export * from "./dl_person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af00acc0')) {
      api.createRecord('af00acc0', component.options)
    } else {
      api.reload('af00acc0', component.options)
    }
    module.hot.accept("./dl_person.vue?vue&type=template&id=af00acc0&", function () {
      api.rerender('af00acc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/dl_person.vue"
export default component.exports